import React from "react";
import EventsListPage from "./EventsListPage";

const UpcomingEvents = ({ events, title }) => {
  return (
    <>
      <EventsListPage events={events} title={title} />
    </>
  );
};

export default UpcomingEvents;
